import { FC } from "react"
import { Modal } from "@/ui/Modal"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./DevToolsModal.module.scss"
import { EmulateEnvironmentSection } from "./ui/EmulateEnvironmentSection"
import { EmulatePhoneDeviceSection } from "./ui/EmulatePhoneDeviceSection"
import { StorageSection } from "./ui/StorageSection"
import { TgInsetsSection } from "./ui/TgInsetsSection"

const modalType = "devTools"

export const DevToolsModal: FC = () => {
  return (
    <Modal.Center type={modalType}>
      <Modal.StoneFlexContainer
        content={{ className: styles.DevToolsModal_content }}
      >
        <OutlinedText className={styles.DevToolsModal_title}>
          DEV MENU
        </OutlinedText>
        <div className={styles.DevToolsModal_sections}>
          <StorageSection />
          <TgInsetsSection />
          <EmulatePhoneDeviceSection />
          <EmulateEnvironmentSection />
        </div>
      </Modal.StoneFlexContainer>
    </Modal.Center>
  )
}
